import BrandLogo from "@/components/BrandLogo";
import useBranding from "@/hooks/useBranding";
import { MapPin, Phone, Mail, Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const { branding } = useBranding();

  return (
    <footer className="bg-[#050505] text-[#FAF9F6] mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <BrandLogo
            src={branding.footer_logo || branding.header_logo}
            label="Maharlika"
            sublabel="Seafood Mart & Chow"
            variant="dark"
            size="sm"
            className="mb-4"
          />

          <p className="text-sm text-[#8A8A8A] leading-relaxed font-heading italic">
            "{branding.tagline || "Where Filipino Tradition Meets Fresh Quality."}"
          </p>
        </div>

        <div>
          <h4 className="font-accent text-xs text-[#D4AF37] mb-3">VISIT US</h4>
          <ul className="space-y-2 text-sm text-[#FAF9F6]/70">
            <li className="flex gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-[#D4AF37]" strokeWidth={1.5} />
              44164 10th St W, Lancaster, CA 93534
            </li>
            <li className="flex gap-2">
              <Phone className="w-4 h-4 mt-0.5 text-[#D4AF37]" strokeWidth={1.5} />
              Mart: 661-206-8619
            </li>
            <li className="flex gap-2">
              <Phone className="w-4 h-4 mt-0.5 text-[#D4AF37]" strokeWidth={1.5} />
              Restaurant: 661-206-7487
            </li>
            <li className="flex gap-2">
              <Mail className="w-4 h-4 mt-0.5 text-[#D4AF37]" strokeWidth={1.5} />
              msmac0428@gmail.com
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-accent text-xs text-[#D4AF37] mb-3">HOURS</h4>
          <ul className="space-y-1.5 text-sm text-[#FAF9F6]/70">
            <li>Restaurant — Mon–Sun 10:30am–7:00pm</li>
            <li>Mart — Mon–Sat 9:30am–6:30pm</li>
            <li>Mart — Sun 9:00am–5:30pm</li>
          </ul>
        </div>

        <div>
          <h4 className="font-accent text-xs text-[#D4AF37] mb-3">EXPLORE</h4>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/restaurant" className="text-[#FAF9F6]/70 hover:text-[#D4AF37]">Restaurant Menu</Link></li>
            <li><Link to="/grocery" className="text-[#FAF9F6]/70 hover:text-[#D4AF37]">Seafood Mart</Link></li>
            <li><Link to="/lechon" className="text-[#FAF9F6]/70 hover:text-[#D4AF37]">Reserve Lechon</Link></li>
            <li><Link to="/catering" className="text-[#FAF9F6]/70 hover:text-[#D4AF37]">Catering</Link></li>
            <li><Link to="/rewards" className="text-[#FAF9F6]/70 hover:text-[#D4AF37]">Royal Rewards</Link></li>
          </ul>

          <div className="flex gap-3 mt-4">
            <a href="#" className="w-9 h-9 rounded-full border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#050505] transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 rounded-full border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#050505] transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#D4AF37]/20 py-5 px-4 text-center text-xs text-[#FAF9F6]/40">
        © {new Date().getFullYear()} Maharlika Seafood Mart & Chow · ChowMaharlika · Lancaster, CA
      </div>
    </footer>
  );
}
